import { redirect } from 'react-router'

import { hasOnlinePaymentSectionEnabled } from '@/resources/services/permission/permissions'

export function requireOnlinePaymentAccess() {
  if (!hasOnlinePaymentSectionEnabled()) {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- redirect() is the supported guard pattern
    throw redirect('/poc-orders')
  }

  return null
}
